
/*
    Context object for wrapping around the data on each page,
    used as an easy way to manage reloading the data within
    its container as triggered by a control within the banner
*/

import React from "react";

const DataContext = React.createContext({});

export default DataContext;